define([
	'internal_util/Util'
], function (
	Util
) {
	'use strict';

	/**
	 * Card class
	 * 
	 * @param id
	 * @param type
	 * @param slot
	 * @returns {Card}
	 */
	return function (id, type, slot) {
		var _id,
			_type,
			_slot;

		if (Util.isValidString(id)) {
			_id = id;
		} else {
			throw new Error('invalid card id: ' + id);
		}

		if (Util.isValidString(type)) {
			_type = type;
		} else {
			throw new Error('invalid card type: ' + type);
		}

		if (Util.isValidString(slot)) {
			_slot = slot;
		} else {
			throw new Error('invalid card slot: ' + slot);
		}


		// public methods

		this.id = function () {
			return _id;
		};

		this.type = function () {
			return _type;
		};

		this.slot = function () {
			return _slot;
		};

		this.toObject = function () {
			return {
				id : _id,
				type : _type,
				slot : _slot
			};
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/Card.js
// module id = 285
// module chunks = 3